export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_34361.0158d55c.jpg";